import * as React from 'react'
import { useState, useEffect, useRef, useMemo } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, scopedCssBaselineClasses, Container, Stack, CircularProgress } from '@mui/material'
import { findCode, printVariable, sanitizeFilename } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import useAlert from '@hooks/useAlert'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import Box from '@mui/material/Box'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import '@scss/App.scss'
import consoleLogger from 'react-terminal-logger/console-logger'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles';
import { LineCart, LineChart, } from '@mui/x-charts/LineChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import { useAnimate, useAnimateBar, useDrawingArea } from '@mui/x-charts/hooks';
import { PiecewiseColorLegend } from '@mui/x-charts/ChartsLegend';
import { interpolateObject } from '@mui/x-charts-vendor/d3-interpolate';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManagerSurveyPartIndi from './manager-survey.part.indi'
import * as ExcelJS from 'exceljs'
import ExcelExporter from '@components/ExcelExporter'
import { transformToMatrix, transformToMatrix2 } from './manager-survey.part.indi'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
// import { FixedSizeList } from 'react-window'
// import FixedSizeList from 'react-window/'
import { VariableSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer';

const ManagerSurveyPartStat = ({ record, dialogHandler, tabValue, callback }) => {
  const [quests, set_quests] = useState([])
  const [surveySum, set_surveySum] = useState([])
  const [openSnackbar] = useSnackbar()
  const [replUserCnt, set_replUserCnt] = useState()
  const [topicUserCnt, set_topicUserCnt] = useState()
  const [subjRepls, set_subjRepls] = useState([])
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const detailHandler = useState(false)
  const [isLoading, set_isLoading] = useState(true)
  const [smst, set_smst] = useState({})
  const [ansCntByLecture, set_ansCntByLecture] = useState({})
  const [lectures, set_lectures] = useState([])
  const lecturesOriginRef = useRef([])
  const replsRef = useRef([])
  const schola = useSelector(state => state.scholaReducer);
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const flatListItems = useMemo(() => {
    const items = [];
    if (lectures.length > 0 && quests.length > 0) {
      lectures.forEach((lecture) => {
        items.push({ type: 'HEADER', lecture });
        quests.forEach((quest) => {
          items.push({ type: 'QUEST', lecture, quest });
        });
      });
    }

    return items;
  }, [lectures, quests])

  const getItemSize = (index) => {
    const item = flatListItems[index];
    return item.type === 'HEADER' ? 70 : 300 // 헤더는 짧게, 질문은 높게
  }

  const MyPie = ({ lectureId, questId }) => {
    const rows = surveySum.filter(r => r.lectureId === lectureId && r.questId === questId)
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0)

    const data =
      quests.find(q => q.id === questId)?.anss?.map(ans => {
        const ansCnt = rows.find(r => r.ansId === ans.id)?.ansCnt ?? 0
        const isNoData = total === 0
        const dataItem = {
          id: ans.id,
          value: isNoData ? 1 : ansCnt,
          label: ans.txt,
          formattedLabel: isNoData ? '0 (0%)' : `${ansCnt} ( ${((ansCnt / total) * 100).toFixed(1)}%)`
        }

        if (isNoData) {
          dataItem.color = '#eeeeee';
        }
        return dataItem
      })


    const series = [
      {
        data: data,
        arcLabel: (item) => item.formattedLabel,
        arcLabelMinAngle: 35, // Only show label if slice is big enough
        highlightScope: { faded: 'global', highlighted: 'item' },
      },
    ]

    return (
      <>
        <Typography variant='body2'>응답:{total}</Typography>
        <PieChart
          series={series}
          sx={{
            [`& .MuiPieArcLabel-root`]: {
              fill: 'white',
              fontWeight: 'bold',
              fontSize: 12,
            },
          }}
          width={500}
          height={200}
        />
        {/* {
          total == 0 ? (
            <Typography>이 질문에 응답이 없습니다.</Typography>
          ) : null
        } */}
      </>

    )
  }



  const MyBar = ({ lectureId, questId }) => {
    const rows = surveySum.filter(r => r.lectureId === lectureId && r.questId === questId)
    if (!surveySum.length || rows.length === 0) {
      return <div style={{ height: 200 }}>Loading Chart Data...</div>;
    }
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0);
    const answers = quests.find(q => q.id === questId)?.anss || [];

    if (answers.length === 0) return null
    const axisData = answers.map(ans => ans.txt)

    // const axisData = 
    //   quests.find(q => q.id === questId)?.anss?.map(ans => {
    //     return ans.txt
    //   })

    // const axisData = rows.map(r => {
    //   // 답변 하나가 한 그룹
    //   const txt = quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt
    //   return txt || '삭제된 선택지'
    //   // return quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt
    // })

    const seriesData = [
      {
        data: answers.map(ans => {
          const found = rows.find(r => r.ansId === ans.id);
          return found ? found.ansCnt : 0;
        }),

        // rows.map(r => r.ansCnt),

        // label: '응답수' 
        valueFormatter: (value) => {
          const percent = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
          return `${value} views (${percent}%)`;
        },
      }
    ]

    return (
      <>
        <Typography variant='body2'>응답:{total}</Typography>
        <BarChart
          yAxis={[{
            scaleType: 'band',
            data: axisData,
          }]}
          xAxis={[{
            type: 'number',
            // Force the chart to show a bit of space before the first bar
            // min: -0.01, 
            // Ensure the max value has room for the text labels
            // max: total > 0 ? total + (total * 0.2) : 10 
          }]}
          layout="horizontal"
          series={seriesData}
          barLabel={(item) => {
            if (item.value === 0) return null;
            const percent = total > 0 ? ((item.value / total) * 100).toFixed(0) : 0;
            return `${item.value} (${percent}%)`;
          }}

          height={200}
          width={500}
          margin={{ left: 150, right: 80 }}
        />
        {/* {
          total === 0 ? (
             <Typography>이 질문에 응답이 없습니다.</Typography>
          ) : null
        } */}
      </>

    )
  }
  const MyAccordion = ({ lectureId, questId }) => {
    const rows = surveySum.filter(r => r.lectureId === lectureId && r.questId === questId)
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0);
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }} gap={1}>
        <Typography variant='body2'>응답:{total}</Typography>
        <Grid container>
          <Grid item xs={12}>
            <Accordion
            >
              <AccordionSummary
                id={`repl-${questId}`}
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: '#fafafa', // 필요시 배경색 살짝 추가
                }}
              >
                응답내용
              </AccordionSummary>
              <AccordionDetails>
                {
                  subjRepls.filter(r => r.lectureId === lectureId && r.questId === questId).map((repl) => (
                    <Typography key={`repl-${lectureId}-${questId}-${repl.id}`}>{repl.txt}</Typography>
                  ))
                }
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

      </Box>

    )
  }



  const Row = ({ index, style }) => {
    const item = flatListItems[index]
    return (
      <div style={style}>
        {item.type === 'HEADER' ? (
          <>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <LabelOutlinedIcon />
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {item.lecture.title}
              </Typography>
            </Stack>
            <Stack>
              {
                (() => {
                  const lectureAnsCnt = ansCntByLecture[item.lecture.id] ?? 0
                  const targetCnt = item.lecture.prcNum
                  let ratio = 0.0
                  if (targetCnt > 0) {
                    ratio = (100 * Number(lectureAnsCnt) / Number(targetCnt)).toFixed(1)
                  }

                  return (
                    <Typography variant='body2'>대상: {targetCnt} 응답: {lectureAnsCnt} 비율: {ratio} %</Typography>
                  )
                })()
              }

            </Stack>
          </>

        ) : (
          <Stack key={`${item.lecture.id}-${item.quest.id}`}>
            <Typography style={{ fontWeight: 'bold' }}>{`Q ${item.quest.sqNum}. ${item.quest.txt}`}</Typography>
            {item.quest.questCode === 'Q000' ? (
              <MyPie lectureId={item.lecture.id} questId={item.quest.id} />
            ) : item.quest.questCode === 'Q001' ? (
              <MyBar lectureId={item.lecture.id} questId={item.quest.id} />
            ) : (
              <MyAccordion lectureId={item.lecture.id} questId={item.quest.id} />
            )}
          </Stack>
        )}
      </div>
    )
  }

  const fillSheet1 = (workbook) => {
    const lectureStart = 1
    const questStart = 1
    const gubunStart = 2
    const ansStart = 3
    const exporter = new ExcelExporter(workbook, "분석")

    const title = `${record.title}`
    const term = `설문기간: ${record.startTime.substr(0, 10)} ~ ${record.endTime.substr(0, 10)}`
    let smstName = '대상 강좌 기수: '
    if (smst?.id > 0) {
      smstName += `${smst.year} ${smst.gisu}`
    }
    else {
      smstName += `없음`
    }


    let replRatio = 0
    if (topicUserCnt > 0) {
      replRatio = (100 * Number(replUserCnt) / Number(topicUserCnt)).toFixed(1)
    }

    const replStat = `발송대상자수:${topicUserCnt} 응답사용자수:${replUserCnt} 비율:${replRatio} %`
    const headers = ['문항', '구분', '응답항목/내용', '응답수', '비율']
    exporter.setValue(`${schola.name}`).nextRow()
    exporter.setValue(title).nextRow()
    exporter.setValue(term).nextRow()
    exporter.setValue(smstName).nextRow()
    exporter.setValue(replStat).nextRow()
    exporter.jumpTo(exporter.rownum + 1, 1)
    // exporter.setValue('강좌명').nextCol()
    // exporter.setValue('문항').nextCol()
    // exporter.setValue('구분').nextCol()
    // exporter.setValue('응답항목/내용').nextCol()
    // exporter.setValue('응답수').nextCol()
    // exporter.setValue('비율').nextCol()
    // exporter.jumpTo(exporter.rownum + 1, 1)

    lectures.forEach((lecture, lidx) => {
      const lectureTitle = lecture.title

      let lecureSummary = lectureTitle
      if (lecture.id > 0) {
        const lectureTargetCnt = lecture.prcNum
        const teacherName = lecture.user?.name ?? '없음'
        const lectureAnsCnt = ansCntByLecture[lecture.id] ?? 0
        let lectureReplRaio = 0
        if (lectureTargetCnt > 0) {
          lectureReplRaio = (100 * Number(lectureAnsCnt) / Number(lectureTargetCnt)).toFixed(1)
        }
        lecureSummary += `(강사명:${teacherName} 대상자수: ${lectureTargetCnt} 응답자수:${lectureAnsCnt} 비율: ${lectureReplRaio} %)`
      }

      // exporter.setValue(`${lecture.title}`).nextCol()
      exporter.setValue(`${lecureSummary}`).nextRow()

      headers.forEach(h => {
        exporter.setValue(h).nextCol()
      })
      exporter.jumpTo(exporter.rownum + 1, 1)

      quests.forEach((quest, qidx) => {
        exporter.setValue(`Q.${quest.sqNum} ${quest.txt}`).nextCol()
        const gubun = quest.questCode === 'Q002' ? '주관식' : quest.questCode === 'Q000' ? '객관식(단)' : '객관식(복)'
        exporter.setValue(`${gubun}`).nextCol()
        if (quest.questCode !== 'Q002') {
          const questAnsRows = surveySum.filter(r => r.lectureId === lecture.id && r.questId === quest.id)
          const questAnsCount = questAnsRows.reduce((acc, cur) => {return acc + cur.ansCnt}, 0)
          quest.anss.forEach((ans, aidx) => {
            // 객관식
            exporter.setValue(`${ans.txt}`).nextCol()
            const ansCnt = surveySum.find(r => r.lectureId === lecture.id && r.questId === quest.id && r.ansId === ans.id)?.ansCnt ?? 0
            
            exporter.setValue(`${ansCnt}`).nextCol()
            const ratio = questAnsCount == 0 ? 0 : (100 * Number(ansCnt) / Number(questAnsCount)).toFixed(1)
            exporter.setValue(`${ratio} %`).nextCol()
            exporter.jumpTo(exporter.rownum + 1, ansStart)
          })
        }
        else {
          const repls = subjRepls.filter(r => r.lectureId === lecture.id && r.questId === quest.id)
          repls.forEach((repl, ridx) => {
            exporter.setValue(`${repl.txt}`)
            exporter.nextRow()
          })
        }
        exporter.jumpTo(exporter.rownum, questStart)
      })

      exporter.jumpTo(exporter.rownum + 1, lectureStart)
    })

    const columnA = exporter.sheet.getColumn(1); // 1번 컬럼 (A열)
    let maxLen = 0;

    columnA.eachCell({ includeEmpty: true }, (cell) => {
      const cellLength = cell.value ? cell.value.toString().length : 10;
      if (cellLength > maxLen) {
        maxLen = cellLength;
      }
    })
    columnA.width = maxLen < 10 ? 10 : maxLen + 2;
  }

  const fillSheet2 = (workbook, data) => {
    console.log('data=>', data)
    const { headers, rows } = data
    const exporter = new ExcelExporter(workbook, "상세")
    exporter.setValue('No').nextCol()
    // exporter.setValue('전화번호').nextCol()
    exporter.setValue('힉년').nextCol()
    exporter.setValue('반').nextCol()
    exporter.setValue('번호').nextCol()
    exporter.setValue('학생명').nextCol()
    exporter.setValue('보호자전화번호').nextCol()
    exporter.setValue('강좌명').nextCol()

    headers.forEach(header => {
      exporter.setValue(header).nextCol()
    })

    exporter.jumpTo(exporter.rownum + 1, 1)

    const printRow = (row, rowIdx) => {
      exporter.setValue(rowIdx + 1).nextCol()
      exporter.setValue(row.student?.grade ?? '-').nextCol()
      exporter.setValue(row.student?.className ?? '-').nextCol()
      exporter.setValue(row.student?.classNum ?? '-').nextCol()
      exporter.setValue(row.student?.name ?? '-').nextCol()
      exporter.setValue(row.user?.phone ?? '-').nextCol()
      exporter.setValue(row.lecture?.title ?? '-').nextCol()
      row.data.forEach((cell, cellIdx) => {
        exporter.setValue(cell.value).nextCol()
      })

      exporter.jumpTo(exporter.rownum + 1, 1)
    }

    const lectureIds = lectures.map(r => r.id)

    let targetRows = rows
    if(record.modeCode === 'M001' && record.smstId > 0) {
      targetRows = rows.filter(r => lectureIds.includes(r.lecture?.id ))
    }

    targetRows.forEach((row, rowIdx) => {
      printRow(row, rowIdx)
    })
  }

  const handleDownload = async () => {
    const data = await fetchSurveyDetail2()
    if (!data) {
      return
    }

    const workbook = new ExcelJS.Workbook()
    fillSheet1(workbook)
    fillSheet2(workbook, data)


    workbook.xlsx.writeBuffer().then(buffer => {
      // let filename = `${schola.name}_${record.title}`
      let filename = `${record.title}`
      if(lectures.length === 1) {
        filename +=  `_${lectures[0].title}`
      }
      

      filename += `.xlsx`
      filename = sanitizeFilename(filename)

      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    })
  }

  const fetchSurveyDetail = async () => {
    const url = `/survey/detail/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const surveyDetail = JSON.parse(repMessage.surveyDetail)

    const { headers, rows } = transformToMatrix(surveyDetail)
    return ({
      headers: headers,
      rows: rows,
    })
  }

  const fetchSurveyDetail2 = async () => {
    const url = `/survey/detail2/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const surveyDetail = JSON.parse(repMessage.surveyDetail)

    const { headers, rows } = transformToMatrix2(surveyDetail)
    return ({
      headers: headers,
      rows: rows,
    })
  }

  const fetchQuests = async () => {
    if (lectures.length == 0) {
      return
    }

    if (record.id === -1) {
      return
    }

    const url = `/survey/${record.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      useYn: 'A'
    })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    if (records?.length > 0) {
      const quests = records[0].quests
      set_quests(quests)
    }
  }


  const fetchSum = async () => {
    const url = `/survey/sum/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const replUserCnt = Number(repMessage.replUserCnt)
    const topicUserCnt = Number(repMessage.topicUserCnt)
    const subjRepls = JSON.parse(repMessage.subjRepls)
    replsRef.current = JSON.parse(repMessage.repls)

    const lectureStudents = replsRef.current.reduce((acc, curr) => {
      const { lectureId, studentId } = curr
      if (!acc[lectureId]) {
        acc[lectureId] = new Set()
      }
      acc[lectureId].add(studentId)

      return acc
    }, {})

    const ansCntByLecture = Object.entries(lectureStudents).reduce((acc, [lectureId, studentSet]) => {
      acc[lectureId] = studentSet.size
      return acc
    }, {})

    console.log('ansCntByLecture=>', ansCntByLecture)
    set_subjRepls(subjRepls)
    set_replUserCnt(replUserCnt)
    set_topicUserCnt(topicUserCnt)
    set_surveySum(records)
    set_ansCntByLecture(ansCntByLecture)
    set_isLoading(false)
  }

  const fetchSmst = async () => {
    if (record?.modeCode === 'M001' && record?.smstId > 0) {
      const url = `/smst/id/${record.smstId}`
      const resp = await WebService.get(url)
      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      const smst = JSON.parse(repMessage.record)
      set_smst(smst)
    }
  }

  const fetchLectures = async () => {
    if (record?.modeCode === 'M001' && record?.smstId > 0) {
      const url = `/lecture/array/smst/${record.smstId}`
      const resp = await WebService.get(url)
      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      const lectures = JSON.parse(repMessage.records)
      lecturesOriginRef.current = lectures
      set_lectures(lectures)

    }
    else {
      set_lectures([{
        id: -1,
        title: '일반 설문조사'
      }])
    }
  }

  const onLoad = async () => {
    // await fetchLectures()
    // await fetchQuests()
    // await fetchSum()
  }


  useEffect(() => {
    (async () => {
      await fetchSmst()
      await fetchLectures()
    })()

  }, [])

  useEffect(() => {
    fetchQuests()
  }, [lectures])

  useEffect(() => {
    fetchSum()

  }, [quests])

  // useEffect(() => {
  //   onLoad()
  // }, [])

  // if(isLoading) {
  //   return <></>
  // }

  return (
    <Fragment>
      <div>
        {renderIndicator()}
        {renderAlert()}
        {detailHandler[0] ? (<ManagerSurveyPartIndi record={record} dialogHandler={detailHandler} callback={onLoad} />) : null}
      </div>
      <Dialog open={dialogHandler[0]} onClose={handleClose} fullScreen>
        <DialogTitle>
          <Grid container>
            <Grid item xs></Grid>
            <Grid item xs={10}>
              <Box className={'center'}>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  {schola.name}
                </Typography>

                <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
                  {record.title}
                </Typography>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  분석
                </Typography>

              </Box>
            </Grid>
            <Grid item xs style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
          <Container sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Stack direction="column" spacing={2} sx={{ display: 'flex', alignItem: 'center', width: '100%', mt: 1 }}>
              <Stack sx={{minHeight:'100px'}}>
                {
                  replUserCnt ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }} gap={2}>
                      <PeopleAltOutlinedIcon />
                      <Box>
                        {
                          (() => {
                            let ratio = 0.0
                            if (topicUserCnt > 0) {
                              ratio = (100 * Number(replUserCnt) / Number(topicUserCnt)).toFixed(1)
                            }
                            return (
                              <>
                                <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>전체 대상자수: {topicUserCnt}</Typography>
                                <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>전체 응답자수: {replUserCnt}</Typography>
                                <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>비율: {ratio} %</Typography>
                              </>

                            )
                          })()
                        }

                        {/* <Button
                          startIcon={<AssignmentOutlinedIcon />}
                          onClick={() => {
                            detailHandler[1](true)
                          }}
                        >
                          상세보기
                        </Button> */}
                      </Box>


                    </Box>

                  ) : null
                }
              </Stack>
              <Stack direction={'row'} spacing={2}>
                {
                  record?.modeCode === 'M001' ? (
                    <Box sx={{ minWidth: '400px' }}>
                      <FormControl fullWidth size="small" >
                        <InputLabel id='lecture'>
                          강좌선택
                        </InputLabel>
                        <Select
                          fullWidth
                          labelId='lecture'
                          required
                          label='상태'
                          defaultValue={0}
                          // value={row.statCode}
                          onChange={(e) => {
                            let ls = []
                            if (e.target.value === 0) {
                              ls = lecturesOriginRef.current
                            }
                            else {
                              const found = lecturesOriginRef.current.find(r => r.id === e.target.value)
                              if (found) {
                                ls.push(found)
                              }
                            }

                            set_lectures(ls)
                          }}>
                          <MenuItem value={0}>
                            전체
                          </MenuItem>
                          {
                            lecturesOriginRef.current.map((l, index) => (
                              <MenuItem key={index} value={l.id}>
                                {l.title}
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>

                    </Box>
                  ) : null
                }

                <Box>
                  <Button
                    startIcon={<FileDownloadOutlinedIcon />}
                    size='md'
                    onClick={() => {
                      handleDownload()
                    }}
                  >
                    다운로드
                  </Button>
                </Box>
              </Stack>

            </Stack>
            <Stack sx={{ flex: 1, display: 'flex', flexDirection: 'column', mt: 5 }}>
              <AutoSizer>
                {({ height, width }) => (
                  <List
                    height={height}
                    width={width}
                    itemCount={flatListItems.length}
                    itemSize={getItemSize}
                  >
                    {Row}
                  </List>
                )}
              </AutoSizer>
            </Stack>

          </Container>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  )
}

export default ManagerSurveyPartStat